import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { novoDB, triggerLoadNovoDB, unloadDb } from "../dbs/dbsSlice";
import { Alert, Box, Button, Card, Grid, Input, Link, List, ListItem, Stack, Textarea, Typography } from "@mui/joy";
import { extrairTags, removerElementoDoArray, stringDataFormatoJava } from "../helper/functions";
import { gerarGUID } from "../livrudo/livrudo_helpers";
import { setToEdit, updateWorks } from "./WorkSlice";
import { Navigate } from "react-router-dom";
import { BreakfastDining } from "@mui/icons-material";

function juntaHashTags(vetor) {

    var t = "";

    for (var i = 0; i < vetor.length; i++) {
        t += vetor[i];
        if (i < vetor.length - 1) {
            t += ", ";
        }
    }
    return t;
}

function WorkForm() {

    var dispatch = useDispatch();
    var works = useSelector((state) => state.work.db.works);
    var toEdit = useSelector((state) => state.work.toEdit);

    const [form, setForm] = useState({
        redirectAfter: false,
        id: null,
        error: null,
        titulo: "",
        descricao: "",
        bullet: "",
        bullets: [],
        hashtags: "",
        toEdit: null,
        textoBotaoAdicionar: "Adcionar",
    });

    React.useEffect(() => {
        if (toEdit !== null) {
            console.log("inicio");
            var nEdit = JSON.parse(JSON.stringify(toEdit))
            handleChange("toEdit", nEdit);
            handleChange("error", null);
            handleChange("id", nEdit.id);
            handleChange("titulo", nEdit.titulo);
            handleChange("descricao", nEdit.descricao);
            handleChange("bullets", nEdit.bullets);
            handleChange("hashtags", nEdit.hashtags);
            handleChange("textoBotaoAdicionar", "Salvar alterações");

            // var nWorks = JSON.parse(JSON.stringify(works));
            // nWorks.forEach(n => n.dataPriorizacao = null);
            // dispatch(updateWorks(nWorks));

        }
    }, []);

    const handleChange = (field, value) => {
        setForm((prev) => ({ ...prev, [field]: value }))
    }

    const cancelarEdicao = () => {
        dispatch(setToEdit(null));
        handleChange("redirectAfter", true);
    }

    const adicionar = () => {
        handleChange("error", null);
        if (form.titulo.length < 1) {
            handleChange("error", "Título inválido");
        } else if (form.descricao.length < 1) {
            handleChange("error", "Descrição muito curta");
        } else {
            if (form.toEdit === null) {
                var novoWork = {
                    id: gerarGUID(),
                    data: stringDataFormatoJava(new Date()),
                    dataConclusao: null,
                    dataCancelamento: null,
                    dataPriorizacao: null,
                    titulo: form.titulo,
                    descricao: form.descricao,
                    bullets: form.bullets,
                    hashtags: juntaHashTags(extrairTags(form.hashtags)),
                }
                var nWorks = [novoWork, ...works];
                dispatch(updateWorks(nWorks));
                handleChange("redirectAfter", true);
            } else {
                var nToEdit = JSON.parse(JSON.stringify(form.toEdit))
                var editarWork = {
                    ...nToEdit,
                    titulo : form.titulo,
                    titulo: form.titulo,
                    descricao: form.descricao,
                    bullets: form.bullets,
                    hashtags: juntaHashTags(extrairTags(form.hashtags)),
                }

                var nWorks = [...works];
                var index = -1;
                for(var i = 0; i < works.length; i++) {
                    if(works[i].id == nToEdit.id) {
                        index = i;
                        break;
                    }
                }

                nWorks[index] = editarWork;
                dispatch(updateWorks(nWorks));
                dispatch(setToEdit(null));
                handleChange("redirectAfter", true);
            }
        }
    }

    const addBullet = () => {
        handleChange("error", null);
        if (form.bullet.trim().length < 1) {
            handleChange("error", "Não tem nada no bullet.");
        } else {
            var b = [...form.bullets];
            b.push(form.bullet)
            handleChange("bullet", "");
            handleChange("bullets", b);
        }
    }

    const removeBullet = (index) => {
        handleChange("bullets", removerElementoDoArray(form.bullets, index));
    }

    if (form.redirectAfter) {
        return <Navigate to={"/work"} />
    }

    return <Grid xs={12}>
        <Card>
            <Box sx={{ p: 3 }}>
                <Stack spacing={1}>
                    <Typography level="h4">
                        Novo Work
                    </Typography>
                    {form.error != undefined && <Alert color="danger">
                        {form.error}
                    </Alert>}
                    <Input
                        placeholder="Título"
                        value={form.titulo}
                        onChange={(e) => handleChange("titulo", e.target.value)}
                        required
                    />
                    <Textarea
                        minRows={5}
                        value={form.descricao}
                        placeholder="Descrição..."
                        // disabled={processando}
                        onChange={(e) => handleChange("descricao", e.target.value)}></Textarea>

                    <Input
                        placeholder="Hashtags (#tags,)"
                        value={form.hashtags}
                        onChange={(e) => handleChange("hashtags", e.target.value)}
                        required
                    />
                    <Box style={{ width: "100%" }}>
                        <Stack direction={"row"} spacing={1}>
                            <Input
                                placeholder="Bullet"
                                value={form.bullet}
                                onChange={(e) => handleChange("bullet", e.target.value)}
                                required
                                sx={{ width: "100%" }}
                            />
                            <Button onClick={() => addBullet()}>+</Button>
                        </Stack>
                        <Stack>
                            <List marker={"disc"}>
                                {form.bullets != undefined && form.bullets.map((a, index) => {
                                    return <ListItem key={index}>
                                        <Stack direction={"row"} spacing={1} alignItems={"center"}>
                                            <Button color="danger" onClick={() => removeBullet(index)}>x</Button>
                                            <Typography>{a}</Typography>
                                        </Stack>
                                    </ListItem>
                                })}
                            </List>
                        </Stack>
                    </Box>
                    <Box>
                        <Stack direction="row" spacing={1}>
                            <Button onClick={() => adicionar()}>{form.textoBotaoAdicionar}</Button>

                            {toEdit !== null && <Button onClick={() => cancelarEdicao()} color="danger">Cancelar</Button>}
                        </Stack>

                    </Box>
                </Stack>
            </Box>
        </Card>
    </Grid>
}

function AddWorkPage() {
    return <Grid container sx={{ padding: "5px 10px" }}>
        <WorkForm />
    </Grid>
}

export default AddWorkPage;